@if ({
  manufacturerCampaignDetails: manufacturerCampaignDetails$ | async,
  errorDetails: errorDetails$ | async
  }; as type) {
  @if (manufacturerCampaignDetails || errorDetails) {
    <div class="modal-header">
      <h4 class="modal-title" id="modal-title">
        {{ "customManufacturerCampaign.details.title" | cxTranslate }}
      </h4>
      <button type="button" class="close" aria-describedby="modal-title" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="container-fluid">
        <div class="manufacturerCampaignDetails">
          <div class="row">
            <div class="col-4 col-sm-4">
              <p>{{ "customManufacturerCampaign.manufacturer" | cxTranslate }}:</p>
            </div>
            <div class="col-4 col-sm-4">
              <p>{{ manufacturer }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-4 col-sm-4">
              <p>{{ "customManufacturerCampaign.campaign" | cxTranslate }}:</p>
            </div>
            <div class="col-4 col-sm-4">
              <p class="campaignId">{{ campaignId }} - </p>
              <p class="campaignName">{{ campaignName }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col-4 col-sm-4">
              <p>{{ "customManufacturerCampaign.details.product" | cxTranslate }}:</p>
            </div>
            <div class="col-4 col-sm-8">
              <p class="productCode">{{ productCode }} - </p>
              <p class="productName">{{ productName }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col-4 col-sm-4">
              <p>{{ "customManufacturerCampaign.details.manufacturerArticleNo" | cxTranslate }}:</p>
            </div>
            <div class="col-4 col-sm-4">
              <p>{{ supplierArticleNumber }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-4 col-sm-4">
              <p>{{ "customManufacturerCampaign.search.ean" | cxTranslate }}:</p>
            </div>
            <div class="col-4 col-sm-4">
              <p>{{ productEan }}</p>
            </div>
          </div>
        </div>
        @if (!expired && startedValidity) {
          <div class="instructionsParagraph"
            [innerHTML]="'customManufacturerCampaign.details.updateParagraph' | cxTranslate">
          </div>
        }
        <form #updateForm="ngForm" autocomplete="off">
          <table class="table manufacturer-campaign-details-table">
            <thead class="manufacturer-campaign-details-thead-mobile">
              <th scope="col"
                [ngClass]="noSerialNumberCheck && tradeInProduct ? 'serialNumbers header-top' : 'serialNumbers' ">
                {{ 'customManufacturerCampaign.details.serialNumbers' | cxTranslate }}
                @if (!noSerialNumberCheck) {
                  <span class="required">
                    {{ 'customManufacturerCampaign.details.required' |cxTranslate }}
                  </span>
                }
              </th>
              @if (campaignCodeInput) {
                <th scope="col" class="campaignCode">
                  {{ 'customManufacturerCampaign.details.campaignCode' | cxTranslate }}
                  <span class="required">{{ 'customManufacturerCampaign.details.required' | cxTranslate }}</span>
                </th>
              }
              <th scope="col" class="salesDate">
                {{ 'customManufacturerCampaign.details.salesDate' | cxTranslate }}
                <span class="required">{{ 'customManufacturerCampaign.details.required' | cxTranslate }}</span>
              </th>
              @if (tradeInProduct) {
                <th scope="col" class="tradeInProduct">
                  {{ 'customManufacturerCampaign.details.tradeInSerialNo' | cxTranslate }}
                  <span class="required">{{ 'customManufacturerCampaign.details.required' | cxTranslate }}</span>
                </th>
              }
              @if (tradeInProduct) {
                <th scope="col" class="tradeInProduct header-top">
                  {{ 'customManufacturerCampaign.details.tradeInName' | cxTranslate }}
                  <span class="required">{{ 'customManufacturerCampaign.details.required' | cxTranslate }}</span>
                </th>
              }
              @if (numberOfCombinations != 'ZERO') {
                <th scope="col" class="combiArticles">
                  {{ 'customManufacturerCampaign.details.combiArticles' | cxTranslate }}
                  <span class="required">{{ 'customManufacturerCampaign.details.required' | cxTranslate }}</span>
                </th>
              }
              @if (numberOfCombinations != 'ZERO') {
                <th scope="col" class="serialNumbers">
                  {{ 'customManufacturerCampaign.details.serialNumbers' | cxTranslate }}
                  <span class="required">{{ 'customManufacturerCampaign.details.required' | cxTranslate }}</span>
                </th>
              }
              @if (!expired && startedValidity) {
                <th scope="col" class="serialUpdate">
                </th>
              }
            </thead>
            <tbody>
              @if (emptyTable) {
                <tr>
                  <td class="manufacturerCampaignDetailsEmpty" colspan="4">
                    {{ 'customManufacturerCampaign.emptyTable' | cxTranslate }}
                  </td>
                </tr>
              }
              <!-- Editable rows-->
              @for (manufacturerCampaign of manufacturerCampaignDetails; track manufacturerCampaign; let i = $index) {
                @if (!expired && startedValidity && manufacturerCampaign && isEntryOpen(manufacturerCampaign)) {
                  <tr>
                    <!-- Edit Serial Number -->
                    <td class="updateSerialNumber">
                      <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                      <div class="manufacturer-campaign-details-value">
                        <input type="text" class="form-control" name="updateSerialNumber[{{ i }}]"
                          [(value)]="manufacturerCampaign.serialNr" [ngModel]="manufacturerCampaign.serialNr"
                          [required]="!noSerialNumberCheck" (ngModelChange)="modifiedEntry()"/>
                        </div>
                      </td>
                      <!-- Edit campaign code -->
                      @if (campaignCodeInput) {
                        <td class="updateCampaignCode" >
                          <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                          <div class="manufacturer-campaign-details-value">
                            <input type="text" class="form-control" name="updateCampaignCode[{{ i }}]"
                              [(value)]="manufacturerCampaign.campaignCode"
                              [ngModel]="manufacturerCampaign.campaignCode"
                              required (ngModelChange)="modifiedEntry()"/>
                            </div>
                          </td>
                        }
                        <!-- Edit Sales Date -->
                        <td class="updateSalesDate">
                          <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                          <div class="manufacturer-campaign-details-value">
                            <input type="date" class="form-control" name="updateSalesDate[{{ i }}]"
                              [value]="manufacturerCampaign.formattedSalesDate | date:'yyyy-MM-dd'"
                              [ngModel]="manufacturerCampaign.formattedSalesDate | date:'yyyy-MM-dd'" required
                              (ngModelChange)="modifiedEntry()"/>
                            </div>
                          </td>
                          <!-- Edit TradeIn Serial Nr -->
                          @if (tradeInProduct) {
                            <td class="updateTradeInSerialNumber">
                              <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                              <div class="manufacturer-campaign-details-value">
                                <input type="text" class="form-control" name="updateTradeInSerialNumber[{{ i }}]"
                                  [(value)]="manufacturerCampaign.tradeInSerialNo"
                                  [ngModel]="manufacturerCampaign.tradeInSerialNo" required
                                  (ngModelChange)="modifiedEntry()"/>
                                </div>
                              </td>
                            }
                            <!-- Edit TradeIn Name -->
                            @if (tradeInProduct) {
                              <td class="updateTradeInName">
                                <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                <div class="manufacturer-campaign-details-value">
                                  <input type="text" class="form-control" name="updateTradeInName[{{ i }}]"
                                    [(value)]="manufacturerCampaign.tradeInName" [ngModel]="manufacturerCampaign.tradeInName"
                                    required (ngModelChange)="modifiedEntry()"/>
                                  </div>
                                </td>
                              }
                              <!--Edit Combi Product 1 -->
                              @if (numberOfCombinations != 'ZERO') {
                                <td class="updateCombiProduct_1">
                                  <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                  <div class="manufacturer-campaign-details-value">
                                    <ng-select class="ml-2" name="updateCombiProduct_1[{{ i }}]" [searchable]="false"
                                      [clearable]="false" [ngModel]="manufacturerCampaign.combiProduct_1?.code"  required (ngModelChange)="modifiedEntry()">
                                      @for (product of combiProducts; track product) {
                                        <ng-option [value]="product.code">
                                          <span data-toggle="tooltip" title="{{product.code}} - {{product.name}}"> {{product.code}} - {{product.name}}</span>
                                        </ng-option>
                                      }
                                    </ng-select>
                                  </div>
                                </td>
                              }
                              <!--Edit Combi Product 1 Serial Number  -->
                              @if (numberOfCombinations != 'ZERO') {
                                <td class="updateCombiProductSerialNo_1">
                                  <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                  <div class="manufacturer-campaign-details-value">
                                    <input type="text" class="form-control" [ngModel]="manufacturerCampaign.combiProductSerialNo_1"
                                      name="updateCombiProductSerialNo_1[{{ i }}]"
                                      [value]="manufacturerCampaign.combiProductSerialNo_1" required (ngModelChange)="modifiedEntry()"/>
                                    </div>
                                  </td>
                                }
                                <!--Delete Sales Notification-->
                                <td class="deleteSerialNumber">
                                  <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                  <div class="manufacturer-campaign-details-value">
                                    <a class="delete" title="{{'customManufacturerCampaign.buttons.delete' | cxTranslate}}" (click)="onDeleteSerialNumber(i,manufacturerCampaign.pk)">
                                      <cx-icon type="TRASH"></cx-icon>
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            }
                            @if (!expired && startedValidity && manufacturerCampaign && numberOfCombinations === 'TWO' && isEntryOpen(manufacturerCampaign)) {
                              <tr>
                                <td [attr.colspan]="1 + (campaignCodeInput ? 1 : 0) + (tradeInProduct ? 2 : 0)"></td>
                                <td class="combi-optional">@if (isRequired == false) {
                                  <div>{{ 'customManufacturerCampaign.details.combiArticleOptional' | cxTranslate }}</div>
                                } </td>
                                <!--Edit Combi Product 2 -->
                                <td class="updateCombiProduct_2">
                                  <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                  <div class="manufacturer-campaign-details-value">
                                    <ng-select class="ml-2" name="updateCombiProduct_2[{{ i }}]" [searchable]="false"
                                      [clearable]="false" [ngModel]="manufacturerCampaign.combiProduct_2?.code" >
                                      @for (product of combiProducts; track product) {
                                        <ng-option [value]="product.code" required (ngModelChange)="modifiedEntry()">
                                          <span data-toggle="tooltip" title="{{product.code}} - {{product.name}}"> {{product.code}} - {{product.name}}</span>
                                        </ng-option>
                                      }
                                    </ng-select>
                                  </div>
                                </td>
                                <!--Edit Combi Product 2 Serial Number  -->
                                <td class="updateCombiProductSerialNo_2">
                                  <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                  <div class="manufacturer-campaign-details-value">
                                    <input type="text" class="form-control" [ngModel]="manufacturerCampaign.combiProductSerialNo_2"
                                      name="updateCombiProductSerialNo_2[{{ i }}]"
                                      [value]="manufacturerCampaign.combiProductSerialNo_2" [required]="isRequired" (ngModelChange)="modifiedEntry()"/>
                                    </div>
                                  </td>
                                </tr>
                              }
                            }
                            <!-- Uneditable rows-->
                            @for (manufacturerCampaign of manufacturerCampaignDetails; track manufacturerCampaign; let i = $index) {
                              @if (manufacturerCampaign && (expired || !startedValidity || !isEntryOpen(manufacturerCampaign))) {
                                <tr>
                                  <!--Serial Number-->
                                  <td class="serialNumber">
                                    <div class="d-md-none manufacturer-campaign-details-label">
                                      {{ 'customStockProtection.details.serialNumbers' | cxTranslate }}
                                    </div>
                                    <div class="manufacturer-campaign-details-value">
                                      {{manufacturerCampaign.serialNr}}
                                    </div>
                                  </td>
                                  <!-- campaign code -->
                                  @if (campaignCodeInput) {
                                    <td class="campaignCode">
                                      <div class="d-md-none manufacturer-campaign-details-label">
                                        {{ 'customManufacturerCampaign.details.campaignCode' | cxTranslate }}
                                      </div>
                                      <div class="manufacturer-campaign-details-value">
                                        {{manufacturerCampaign.campaignCode}}
                                      </div>
                                    </td>
                                  }
                                  <!--Sales Date -->
                                  <td class="salesDate">
                                    <div class="d-md-none manufacturer-campaign-details-label">
                                      {{ 'customManufacturerCampaign.details.salesDate' | cxTranslate }}
                                    </div>
                                    <div class="manufacturer-campaign-details-value">
                                      {{manufacturerCampaign.salesDateForDisplay}}
                                    </div>
                                  </td>
                                  <!--TradeIn Serial Nr -->
                                  @if (tradeInProduct) {
                                    <td class="tradeInSerialNo">
                                      <div class="d-md-none manufacturer-campaign-details-label">
                                        {{ 'customManufacturerCampaign.details.tradeInSerialNo' | cxTranslate }}
                                      </div>
                                      <div class="manufacturer-campaign-details-value">
                                        {{manufacturerCampaign.tradeInSerialNo}}
                                      </div>
                                    </td>
                                  }
                                  <!--TradeIn Name -->
                                  @if (tradeInProduct) {
                                    <td class="tradeInName">
                                      <div class="d-md-none manufacturer-campaign-details-label">
                                        {{ 'customManufacturerCampaign.details.tradeInName' | cxTranslate }}
                                      </div>
                                      <div class="manufacturer-campaign-details-value">
                                        {{manufacturerCampaign.tradeInName}}
                                      </div>
                                    </td>
                                  }
                                  <!--Combi Products-->
                                  @if (numberOfCombinations != 'ZERO') {
                                    <td class="combiProducts">
                                      <div class="d-md-none manufacturer-campaign-details-label">
                                        {{ 'customManufacturerCampaign.details.combiArticles' | cxTranslate }}
                                      </div>
                                      <div class="manufacturer-campaign-details-value">
                                        {{ 'customManufacturerCampaign.details.combiProduct1' | cxTranslate }} {{manufacturerCampaign.combiProduct_1?.code}}
                                      </div>
                                      @if (numberOfCombinations == 'TWO') {
                                        <div class="manufacturer-campaign-details-value">
                                          {{ 'customManufacturerCampaign.details.combiProduct2' | cxTranslate }} {{manufacturerCampaign.combiProduct_2?.code}}
                                        </div>
                                      }
                                    </td>
                                  }
                                  <!--Combi Products Serial Nos-->
                                  @if (numberOfCombinations != 'ZERO') {
                                    <td class="combiProducts">
                                      <div class="d-md-none manufacturer-campaign-details-label">
                                        {{ 'customManufacturerCampaign.details.combiSerialNumbers' | cxTranslate }}
                                      </div>
                                      <div class="manufacturer-campaign-details-value">
                                        {{ 'customManufacturerCampaign.details.combiProduct1' | cxTranslate }} {{manufacturerCampaign.combiProductSerialNo_1}}
                                      </div>
                                      @if (numberOfCombinations == 'TWO') {
                                        <div class="manufacturer-campaign-details-value">
                                          {{ 'customManufacturerCampaign.details.combiProduct2' | cxTranslate }} {{manufacturerCampaign.combiProductSerialNo_2}}
                                        </div>
                                      }
                                    </td>
                                  }
                                  @if (manufacturerCampaign?.entryStatus == 'PROCESSING') {
                                    <td>
                                      <i class="fa-solid fa-lock uig-lock"
                                      title="{{'customManufacturerCampaign.states.processing' | cxTranslate}}"></i>
                                    </td>
                                  }
                                  @if (manufacturerCampaign?.entryStatus == 'PAID') {
                                    <td>
                                      <i class="fa-solid fa-euro-sign uig-euro-sign"
                                      title="{{'customManufacturerCampaign.states.paid' | cxTranslate}}"></i>
                                    </td>
                                  }
                                  @if (manufacturerCampaign?.entryStatus == 'REJECTED') {
                                    <td>
                                      <img src="assets/images/orderhistory/state_with_open_positions.gif"
                                        title="{{'customManufacturerCampaign.states.rejected' | cxTranslate}}"
                                        />
                                      </td>
                                    }
                                  </tr>
                                }
                                <!-- add rows for combi products-->
                              }
                              <!-- New rows-->
                              @if (!expired && startedValidity && addRow) {
                                <tr>
                                  <td class="newSerialNumber">
                                    <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                    <div class="manufacturer-campaign-details-value">
                                      <input type="text" id="newSerialNumber" class="form-control" [(ngModel)]="newSerialNumber"
                                        name="newSerialNumber" [value]="newSerialNumber" />
                                      </div>
                                    </td>
                                    @if (campaignCodeInput) {
                                      <td class="newCampaignCode">
                                        <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                        <div class="manufacturer-campaign-details-value">
                                          <input type="text" id="newCampaignCode" class="form-control" [(ngModel)]="newCampaignCode"
                                            name="newCampaignCode" [value]="newCampaignCode" />
                                          </div>
                                        </td>
                                      }
                                      <td class="newSalesDate">
                                        <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                        <div class="manufacturer-campaign-details-value">
                                          <input type="date" id="newSalesDate" class="form-control" [(ngModel)]="newSalesDate"
                                            name="newSalesDate" [value]="newSalesDate" />
                                          </div>
                                        </td>
                                        @if (tradeInProduct) {
                                          <td class="newTradeInSerialNumber">
                                            <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                            <div class="manufacturer-campaign-details-value">
                                              <input type="text" id="newTradeInSerialNumber" class="form-control"
                                                [(ngModel)]="newTradeInSerialNumber" name="newTradeInSerialNumber"
                                                [value]="newTradeInSerialNumber" />
                                              </div>
                                            </td>
                                          }
                                          @if (tradeInProduct) {
                                            <td class="newTradeInName">
                                              <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                              <div class="manufacturer-campaign-details-value">
                                                <input type="text" id="newTradeInName" class="form-control" [(ngModel)]="newTradeInName"
                                                  name="newTradeInName" [value]="newTradeInName" />
                                                </div>
                                              </td>
                                            }
                                            @if (numberOfCombinations != 'ZERO') {
                                              <td class="newCombiProduct_1">
                                                <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                                <div class="manufacturer-campaign-details-value">
                                                  <ng-select class="ml-2" id="newCombiProduct_1" name="newCombiProduct_1" [searchable]="false"
                                                    [clearable]="false" [(ngModel)]="newCombiProduct_1"
                                                    placeholder="{{ 'customManufacturerCampaign.details.placeholder_1' | cxTranslate }}">
                                                    @for (product of combiProducts; track product) {
                                                      <ng-option [value]="product.code">
                                                        <span data-toggle="tooltip" title="{{product.code}} - {{product.name}}"> {{product.code}} - {{product.name}}</span>
                                                      </ng-option>
                                                    }
                                                  </ng-select>
                                                </div>
                                              </td>
                                            }
                                            @if (numberOfCombinations != 'ZERO') {
                                              <td class="newCombiProductSerialNo_1">
                                                <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                                <div class="manufacturer-campaign-details-value">
                                                  <input type="text" id="newCombiProductSerialNo_1" class="form-control"
                                                    [(ngModel)]="newCombiProductSerialNo_1" name="newCombiProductSerialNo_1"
                                                    [value]="newCombiProductSerialNo_1" />
                                                  </div>
                                                </td>
                                              }
                                              <!--Add Sales Notification-->
                                              <td class="addSalesNotification">
                                                <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                                <div class="manufacturer-campaign-details-value">
                                                  <a class="add" title="{{'customManufacturerCampaign.buttons.add' | cxTranslate}}"
                                                    (click)="onAddSalesNotification()">
                                                    <cx-icon type="EXPAND"></cx-icon>
                                                  </a>
                                                </div>
                                              </td>
                                            </tr>
                                            @if (numberOfCombinations == 'TWO') {
                                              <tr>
                                                <td [attr.colspan]="1 + (campaignCodeInput ? 1 : 0) + (tradeInProduct ? 2 : 0)"></td>
                                                <td class="combi-optional">@if (isRequired == false) {
                                                  <div>{{ 'customManufacturerCampaign.details.combiArticleOptional' | cxTranslate }}</div>
                                                } </td>
                                                <td class="newCombiProduct_2">
                                                  <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                                  <div class="manufacturer-campaign-details-value">
                                                    <ng-select class="ml-2" id="newCombiProduct_2" name="newCombiProduct_2" [searchable]="false"
                                                      [clearable]="false" [(ngModel)]="newCombiProduct_2"
                                                      placeholder="{{ 'customManufacturerCampaign.details.placeholder_2' | cxTranslate }}">
                                                      @for (product of combiProducts; track product) {
                                                        <ng-option [value]="product.code">
                                                          <span data-toggle="tooltip" title="{{product.code}} - {{product.name}}"> {{product.code}} - {{product.name}}</span>
                                                        </ng-option>
                                                      }
                                                    </ng-select>
                                                  </div>
                                                </td>
                                                <td class="newCombiProductSerialNo_2">
                                                  <div class="d-md-none manufacturer-campaign-details-label">&nbsp;</div>
                                                  <div class="manufacturer-campaign-details-value">
                                                    <input type="text" id="newCombiProductSerialNo_2" class="form-control"
                                                      [(ngModel)]="newCombiProductSerialNo_2" name="newCombiProductSerialNo_2"
                                                      [value]="newCombiProductSerialNo_2"/>
                                                    </div>
                                                  </td>
                                                </tr>
                                              }
                                            }
                                          </tbody>
                                        </table>
                                      </form>
                                    </div>
                                    <div class="modal-footer">
                                      @if (!expired && startedValidity) {
                                        <button type="button" class="btn btn-secondary col-sm-3" type="button"
                                          [disabled]="!updateForm.valid || disableSaveButton" (click)="onSave()">
                                          {{ "customStockProtection.buttons.save" | cxTranslate }}
                                        </button>
                                      }
                                    </div>
                                  </div>
                                } @else {
                                  <cx-spinner></cx-spinner>
                                }
                              }
